/** `meta:pharmacy`, `meta:aldi or meta:lidl` (ADR 0025): a kind of place rather than one place. */
export const isMeta = (v: unknown): v is string =>
  typeof v === "string" && v.trim().toLowerCase().startsWith("meta:");
